// extracted by mini-css-extract-plugin
export default {"group":"CTAGroup_group__jICdl","centred":"CTAGroup_centred__cS2ul","signIn":"CTAGroup_signIn__t3aLk"};